import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../../../../../@core/backend/common/api/http.service";

@Injectable()
export class InventoryCommonApi {
    
  constructor(private api: HttpService) { }

  searchList(url: string, data:any, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }
 
  getById(url: string, options?: any): Observable<any> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  create(url:string, data: any):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost(url, data, header);
  }

  update(url:string, data: any):Observable<any>{
    let header = new HttpHeaders();
   
   return this.api.directPut( url, data, {header:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }

  updateAssessmentCategoryMst(url:string, data: any,id: number, shouldReturn: boolean):Observable<any>{
    let queryParams = new HttpParams()
      .set('id', id.toString())
      .set('returnList', shouldReturn.toString());
   return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams });
  }

  createAssessmentCategoryMst(url:string, data: any,shouldReturn: boolean):Observable<any>{
    let queryParams = new HttpParams()
      .set('returnList', shouldReturn.toString());
   return this.api.directPost( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams });
  }

  listAssessmentCategoryMst(url: string, tenantId: string): Observable<any[]> {
    let queryParams = new HttpParams()
      .set('tenantid', tenantId.toString())
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams});
  }

  riskAssessmentTransMst(url: string , det): Observable<any[]> {
    let queryParams = new HttpParams()
    let params = new HttpParams();
    params = params.append('tenantId' , det.tenantId);
    params = params.append('branchId' , det.branchId);
    if(det.visitId!=undefined &&  det.visitId != null){
      params = params.append('visitId', det.visitId);
    }
    else if(det.admissionId!=undefined &&  det.admissionId != null){
      params = params.append('admissionId', det.admissionId);
    }

    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: params});
  }


  searchApi(url: string , det , data): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('tenantId' , det.tenantId);
    params = params.append('branchId' , det.branchId);
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.directPost( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: params });
  }
  
  updateProducts(url:string,det):Observable<any[]>{
    let queryParams = new HttpParams().set('prnId', det?.prnId.toString());
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get( url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams });
  }

  updateProduct(url: string, det: any): Observable<any[]> {
    let queryParams = new HttpParams().set('prnId', det?.prnId.toString());
    
    let headers = new HttpHeaders({
      'Accept': 'application/vnd.ezovion.hateoas+json'
    });

    let options = {
      headers: headers,
      params: queryParams
    };

    return this.api.put(url, {}, options);
  }

  updated(url:string,det):Observable<any[]>{
  let queryParams = new HttpParams().set('languageVariableId', det?.languageVariableId);
  let headers = new HttpHeaders({
    'Accept': 'application/vnd.ezovion.hateoas+json'
  });

  let options = {
    headers: headers,
    params: queryParams
  };

  return this.api.put(url,det,options);
}
updatedtrans(url:string,det):Observable<any[]>{
  let queryParams = new HttpParams().set('translationID', det?.translationID);
  let headers = new HttpHeaders({
    'Accept': 'application/vnd.ezovion.hateoas+json'
  });

  let options = {
    headers: headers,
    params: queryParams
  };

  return this.api.put(url,det,options);
}

vopdlist(url: string, det?: any): Observable<any[]> {
  let params = new HttpParams();
  params = params.append('tenantId' , det.tenantId);
  params = params.append('branchId' , det.branchId);
  const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: params});
} 

vopdAppPut(url: string, det?: any): Observable<any[]> {
  let params = new HttpParams();
  params = params.append('apptId' , det.apptId);
  params = params.append('tenantId' , det.tenantId);
  params = params.append('branchId' , det.branchId);
  params = params?.append('type' , det?.type);

  const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  // return this.api.put(url,params);
  let options = {
    headers: header,
    params: params
  };

  return this.api.put(url,{},options);
} 

vopd(url: string, det?: any): Observable<any> {
  let params = new HttpParams();
  params = params.append('tenantId' , det.tenantId);
  params = params.append('branchId' , det.branchId);
  params = params.append('visitId' , det.visitId);
  params = params.append('pageName' , det.pageName);
  const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: params});
} 

vopdAppGet(url: string, det?: any): Observable<any> {
  let params = new HttpParams();
  params = params.append('tenantId' , det.tenantId);
  params = params.append('branchId' , det.branchId);
  params = params.append('stateId' , det.stateId);
  params = params.append('districtId' , det.districtId);
  const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: params});
}

vopdOrgGet(url: string, det?: any): Observable<any> {
  let params = new HttpParams();
  params = params.append('stateId' , det.stateId);
  params = params.append('countryId' , det.countryId);
  const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: params});
}

vopdSessionGet(url: string, det?: any): Observable<any> {
  let params = new HttpParams();
  params = params.append('tenantId' , det.tenantId);
  params = params.append('branchId' , det.branchId);
  params = params.append('userMobileNumber' , det.userMobileNumber);
  params = params.append('isPastSession' , det.isPastSession);
  params = params.append('startDate' , det.startDate);
  params = params.append('stopDate' , det.stopDate);
  const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: params});
}

vopdUpdate(url:string,data?:any):Observable<any[]>{
  let headers = new HttpHeaders({
    'Accept': 'application/vnd.ezovion.hateoas+json'
  });
  let options = {
    headers: headers,
  };
  return this.api.put(url,data,options);
}

}
